import { message } from "antd";
import axiosInstance from "../../helpers/axios";
import { responseDataFormate } from "../../helpers/bycrypt";
import { API_URL } from "../../helpers/utils";

interface GetSettingsParams {
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const getSettingsAPI =
  ({ onSuccess, onError }: GetSettingsParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/settings`);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to fetch settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Fetch settings error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to fetch settings";
      message.error(errorMessage);
    }
  };

interface UpdateSettingsParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

// 2. The Thunk Action
export const updateSettingsAPI =
  ({ payload, onSuccess, onError }: UpdateSettingsParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/settings`, payload);

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message || "Settings updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update settings error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to update settings";
      message.error(errorMessage);
    }
  };

interface UpdateQuoteEmailTemplateParams {
  payload: {
    mail_subject: string;
    html_template: string;
    is_default?: boolean;
  };
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const updateQuoteEmailTemplateAPI =
  ({ payload, onSuccess, onError }: UpdateQuoteEmailTemplateParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        `${API_URL}/quote-email-templates`,
        payload
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(
          result?.message || "Quote email template updated successfully"
        );
        onSuccess?.(result.data);
      } else {
        message.error(
          result?.message || "Failed to update quote email template"
        );
        onError?.();
      }
    } catch (error: any) {
      console.error("Update quote email template error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message ||
        "Unable to update quote email template";
      message.error(errorMessage);
    }
  };

interface GetQuoteEmailTemplateParams {
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getQuoteEmailTemplateAPI =
  ({ onSuccess, onError }: GetQuoteEmailTemplateParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}/quote-email-templates`
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(
          result?.message || "Failed to fetch quote email template"
        );
        onError?.();
      }
    } catch (error: any) {
      console.error("Get quote email template error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message ||
        "Unable to fetch quote email template";
      message.error(errorMessage);
    }
  };

interface GetSettingsHistoryParams {
  params?: {
    page?: number;
    limit?: number;
    section?: string;
    action?: string;
    start_date?: string;
    end_date?: string;
    search?: string;
  };
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getSettingsHistoryAPI =
  ({ params, onSuccess, onError }: GetSettingsHistoryParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/settings/history`, {
        params,
      });

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to fetch settings history");
        onError?.();
      }
    } catch (error: any) {
      console.error("Fetch settings history error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to fetch settings history";
      message.error(errorMessage);
    }
  };

export const getExchangeRateSettingsAPI =
  ({ onSuccess, onError }: { onSuccess?: (data: any) => void; onError?: () => void; }) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/settings/exchange-rate`);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to fetch exchange rate settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Fetch exchange rate settings error:", error);
      onError?.();
      const errorMessage = error?.response?.data?.message || "Unable to fetch exchange rate settings";
      message.error(errorMessage);
    }
  };

export const updateExchangeRateSettingsAPI =
  ({ payload, onSuccess, onError }: { payload: any; onSuccess?: (data: any) => void; onError?: () => void; }) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/settings/exchange-rate`, payload);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Exchange rate settings updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update exchange rate settings");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update exchange rate settings error:", error);
      onError?.();
      const errorMessage = error?.response?.data?.message || "Unable to update exchange rate settings";
      message.error(errorMessage);
    }
  };
